<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-icon @click="onClick" v-on="on">delete</v-icon>
    </template>
    <span>設定の削除</span>
  </v-tooltip>
</template>

<script>
import { IntervalReportRepository } from '@/models/Report/IntervalReport'
export default {
  name: 'IntervalReportListButtonDelete',
  props: {
    id: {
      type: Number,
      default: 0,
    },
    name: {
      type: String,
      default: '',
    },
  },
  methods: {
    async onClick() {
      const result = await this.$deleteConfirm(`${this.name}を削除しますか？`)
      if (!result) {
        return
      }
      try {
        await IntervalReportRepository.remove(this.id)
        this.$emit('onClickDelete')
      } catch (e) {
        console.error(e)
        throw new Error('削除に失敗しました。')
      }
    },
  },
}
</script>

<style></style>
